/**
 * "Chi sono" / About page copy — static, code-managed content (IT/EN).
 *
 * Previously a MongoDB-backed CMS (routes/content.py) with a per-language
 * admin editor, built for a token-metered hosting environment where manual
 * DB edits were the only way to change copy without burning credits.
 * Now that the repo is edited directly, editing these strings here is
 * simpler and keeps IT/EN in sync in one diff — ask to change copy instead
 * of going through an admin panel.
 */
export const ABOUT_CONTENT = {
  it: {
    'about.hero.overline': 'Analista & Investitore',
    'about.hero.name_line1': 'Gabriele',
    'about.hero.name_line2': 'Denaro',
    'about.hero.tagline': "Vengo dall'automazione industriale, non dalla finanza. Studio i mercati con lo stesso metodo con cui si cerca un guasto: dati alla mano, un'ipotesi alla volta.",

    'about.bio.overline': 'Su di me',
    'about.bio.title': 'Analista, programmatore senior PLC e investitore di lungo periodo',
    'about.bio.p1': "Non arrivo dal mondo della finanza tradizionale. Arrivo da anni di lavoro tecnico, responsabilità, errori costosi, debiti e scelte sbagliate che mi hanno insegnato quanto l'educazione finanziaria possa cambiare davvero una vita. Per molto tempo ho vissuto senza comprendere a fondo il funzionamento del denaro, degli investimenti e delle regole del gioco economico. Quando ho iniziato a studiare seriamente, ho capito che non mi mancava la volontà: mi mancavano gli strumenti.",
    'about.bio.p2': "Oggi unisco il mio background da programmatore senior PLC e problem solver nel mondo dell'automazione industriale a un percorso concreto di studio e approfondimento in economia, mercati e value investing. Ho creato questo progetto per condividere analisi, idee e strumenti che avrei voluto avere anni fa. Ho sempre cercato scorciatoie, ma non ne ho trovate: serve metodo, e serve tempo.",
    'about.bio.p3': "Credo che la libertà non nasca dal caso né dalla fortuna. Nasce dalla conoscenza, dalla disciplina e dalla capacità di costruire nel tempo. Questo sito è il punto d'incontro tra tecnologia, investimenti e autonomia personale.",

    'about.skills.overline': 'Competenze',
    'about.skills.title': 'Aree di competenza',

    'about.philosophy.overline': 'Filosofia di Investimento',
    'about.philosophy.quote': "Il prezzo è ciò che paghi. Il valore è ciò che ottieni.",
    'about.philosophy.author': 'Warren Buffett',
    'about.philosophy.tagline': 'Il principio da cui parte ogni analisi di questo sito',

    'about.projects.overline': 'I miei progetti',
    'about.contact.overline': 'Contatti',
    'about.contact.title': 'Scrivimi',
    'about.contact.subtitle': 'Hai una domanda, una proposta o vuoi semplicemente entrare in contatto? Compila il form qui sotto.',
  },
  en: {
    'about.hero.overline': 'Analyst & Investor',
    'about.hero.name_line1': 'Gabriele',
    'about.hero.name_line2': 'Denaro',
    'about.hero.tagline': 'I come from industrial automation, not from finance. I study markets the way you track down a fault: data in hand, one hypothesis at a time.',

    'about.bio.overline': 'About Me',
    'about.bio.title': 'Analyst, Senior PLC Programmer and Long-Term Investor',
    'about.bio.p1': "I don't come from traditional finance. I come from years of technical work, responsibility, costly mistakes, debt and wrong choices that taught me how much financial education can really change a life. For a long time I lived without deeply understanding how money, investing and the rules of the economic game actually work. When I started studying seriously, I realized it wasn't will I lacked: I was missing the tools.",
    'about.bio.p2': "Today I combine my background as a senior PLC programmer and industrial-automation problem solver with a concrete path of study in economics, markets and value investing. I built this project to share analyses, ideas and tools I wish I had years ago. I always looked for shortcuts, and never found one: it takes method, and it takes time.",
    'about.bio.p3': 'I believe freedom doesn\'t come from chance or luck. It comes from knowledge, discipline and the ability to build over time. This site is the meeting point between technology, investing and personal autonomy.',

    'about.skills.overline': 'Skills',
    'about.skills.title': 'Areas of Expertise',

    'about.philosophy.overline': 'Investment Philosophy',
    'about.philosophy.quote': 'Price is what you pay. Value is what you get.',
    'about.philosophy.author': 'Warren Buffett',
    'about.philosophy.tagline': 'The principle behind every analysis on this site',

    'about.projects.overline': 'My Projects',
    'about.contact.overline': 'Contact',
    'about.contact.title': 'Write to me',
    'about.contact.subtitle': 'Got a question, a proposal or just want to get in touch? Fill in the form below.',
  },
};
